import { memo, useMemo } from 'react';

import classNames from 'classnames';
import { useRole } from 'hooks/useRole';
import PropTypes from 'prop-types';

import { isMediaAffiliate } from 'utils/roles';

import RoleContentController from 'components/RoleContentController/RoleContentController';
import Typography from 'components/UI/Typography/Typography';
import ProgressBar from 'components/pages/RewardSystem/Progress/ProgressBar/ProgressBar';
import ProgressSteps from 'components/pages/RewardSystem/Progress/ProgressSteps/ProgressSteps';

import { ROLES } from 'config/organization';

import CoinIcon from 'images/RewardSystem/coin.png';
import FireIcon from 'images/RewardSystem/fire.png';

import styles from './ProgressWrapper.module.scss';

const ProgressWrapper = ({ barProps, stepsProps }) => {
  const role = useRole();

  const mediaAffiliate = useMemo(() => isMediaAffiliate(role), [role]);

  return (
    <div
      className={classNames(styles.root, { [styles.media]: mediaAffiliate })}
    >
      <RoleContentController roles={[ROLES.defaultUser, ROLES.mediaAffiliate]}>
        {[
          <div key="progress-coin" className={styles.coin}>
            <img src={CoinIcon} alt="coin icon" className={styles.coinIcon} />
          </div>,
          <div key="progress-fire" className={styles.fire}>
            <img src={FireIcon} alt="fire icon" className={styles.fireIcon} />
            <div className={styles.fireCircle} />
          </div>,
        ]}
      </RoleContentController>
      <div
        className={classNames(styles.progress, {
          [styles.media]: mediaAffiliate,
        })}
      >
        <Typography type="text-sm" weight="semibold">
          Complete all marketing activities
        </Typography>
        <RoleContentController
          roles={[ROLES.defaultUser, ROLES.mediaAffiliate]}
        >
          {[
            <ProgressBar key="progress-bar" {...barProps} />,
            <ProgressSteps key="progress-steps" {...stepsProps} />,
          ]}
        </RoleContentController>
      </div>
    </div>
  );
};

ProgressWrapper.propTypes = {
  barProps: PropTypes.shape({
    value: PropTypes.number.isRequired,
  }).isRequired,
  stepsProps: PropTypes.shape({
    stepsAmount: PropTypes.number.isRequired,
    completedAmount: PropTypes.number.isRequired,
  }).isRequired,
};

export default memo(ProgressWrapper);
